import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { connect } from "react-redux";

import Popover from "components/library/Popover";
import Button from "components/library/Button";
import { EDITOR_MODALS } from "config/constants/editor";

import { updateFormAt } from "editor/actions/form";

import styles from "./InstoryNewsletterCTAPopover.css";

class InstoryNewsletterCTAPopover extends React.Component {
  constructor(props) {
    super(props);
    this.calculateOffset = this._calculateOffset.bind(this);
    this.handleOnClick = this._handleOnClick.bind(this);
  }

  _handleOnClick(e) {
    e.preventDefault();
    this.props.updateFormAt("promotion", null);
  }

  _calculateOffset() {
    const popoverHeight = 110;
    const marginOffset = 10;
    if (!this.props.CTA_Element) {
      return;
    }

    const boundingClientRect = this.props.CTA_Element.getBoundingClientRect();
    return {
      top: boundingClientRect.top - popoverHeight / 2 - marginOffset,
      left: "50%",
    };
  }

  isActive() {
    return this.props.isActive && this.props.openModal !== EDITOR_MODALS.LINK;
  }

  render() {
    const position = this.calculateOffset();

    return (
      <Popover
        isOpened={this.isActive()}
        position={position}
        className={styles.root}
        closeModal={this.props.closeModal}
      >
        <Button
          className={classNames(styles.menuItem, styles.red)}
          onClick={this.handleOnClick}
          type="tertiary"
        >
          Delete Promotion
        </Button>
      </Popover>
    );
  }
}

const mapStateToProps = state => {
  return {
    openModal: state.editor.ui.openModal,
  };
};

const mapDispatchToProps = {
  updateFormAt,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InstoryNewsletterCTAPopover);

InstoryNewsletterCTAPopover.propTypes = {
  updateFormAt: PropTypes.func.isRequired,
  openModal: PropTypes.oneOf(Object.values(EDITOR_MODALS)),
  isActive: PropTypes.bool.isRequired,
  CTA_Element: PropTypes.instanceOf(Element),
  closeModal: PropTypes.func.isRequired,
};
